export const ANALYTICS_LOGIN = 'Analytics login';
export const ANALYTICS_LOGOUT = 'Analytics logout';
export const TRACK_PAGE = 'Analytics track page';
export const TRACK_EVENT = 'Analytics track event';
